import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { geoZonesStore } from "geoZones/_stores/geoZonesStore";
import React from "react";
import { PROPERTY_PURPOSE } from "properties/_models/PropertyMdl";
import { TGeoZoneMdl } from "geoZones/_models/GeoZoneMdl";
import { InputSearch } from "_common/ui/forms/InputSearch";

type Props = {
    isHomePage?: boolean;
    purpose: PROPERTY_PURPOSE;
    onSelectGeoZone: (geoZone: TGeoZoneMdl) => void;
    onSelectProperty: (aliasUrl: string) => void;
    value: string;
    setValue: (value: string) => void;
    onClickOnSearchIcon?: () => void;
};

export const SearchBarInput = observer((props: Props) => {
    const { t } = useTranslation();
    return (
        <InputSearch
            value={props.value}
            onChange={(e) => {
                geoZonesStore.setSearch(e.target.value);
                props.setValue(e.target.value);
            }}
            onClick={(e) => (e.target as HTMLInputElement).select()}
            placeholder={t("propertiesPage.searchBar.placeholder")}
            autoComplete="new-password"
            onKeyUp={(e) => {
                if (e.key === "ArrowDown") {
                    e.preventDefault();
                    geoZonesStore.pressArrowDown();
                } else if (e.key === "ArrowUp") {
                    e.preventDefault();
                    geoZonesStore.pressArrowUp();
                } else if (e.key === "Escape") {
                    e.preventDefault();
                    geoZonesStore.open(false);
                } else if (e.key === "Enter" && geoZonesStore.selectedResult) {
                    e.preventDefault();
                    props.onSelectGeoZone(geoZonesStore.selectedResult);
                }
            }}
            onClickOnSearchIcon={props.onClickOnSearchIcon}
            isHomePage={props.isHomePage}
        />
    );
});
